
import { defineComponent, PropType } from 'vue';
import {
    B2CConfirmEmailTokenHeroTileModel,
} from '@/types/B2CcontentServerContract';
import ProfileConfirmChangeEmail from '@/b2c/profile/ui/ProfileConfirmChangeEmail.vue';

export default defineComponent({
    name: 'B2CConfirmEmailTokenHeroTile',
    components: { ProfileConfirmChangeEmail },
    props: {
        content: {
            type: Object as PropType<B2CConfirmEmailTokenHeroTileModel>,
            required: true,
        },
    },
});
